export const theme = {
    name: 'skillsclub',
    customRoutes: [{
        path: 'login',
        loadChildren: () => import('../app/pages/custom/skillsclub/login/login.module').then(m => m.LoginPageModule),
    },
    {
        path: 'login/event-key/:event-key',
        loadChildren: () => import('../app/pages/custom/skillsclub/login/login.module').then(m => m.LoginPageModule),
    },
    {
        path: 'login/access-key/:event-key',
        loadChildren: () => import('../app/pages/custom/skillsclub/login/login.module').then(m => m.LoginPageModule),
    },
    {
        path: 'register',
        loadChildren: () => import('../app/pages/custom/skillsclub/registration/registration.module').then(m => m.RegistrationPageModule),
    },
    {
        path: 'register/event-key/:event-key',
        loadChildren: () => import('../app/pages/custom/skillsclub/registration/registration.module').then(m => m.RegistrationPageModule),
    },
    {
        path: 'register/access-key/:event-key',
        loadChildren: () => import('../app/pages/custom/skillsclub/registration/registration.module').then(m => m.RegistrationPageModule),
    },
    {
        path: 'lost-password',
        loadChildren: () => import('../app/pages/custom/skillsclub/lost-password/lost-password.module').then(m => m.LostPasswordPageModule)
    },
    {
        path: 'set-password',
        loadChildren: () => import('../app/pages/custom/skillsclub/set-password/set-password.module').then(m => m.SetPasswordPageModule)
    },
    {
        path: 'toc',
        loadChildren: () => import('../app/pages/custom/skillsclub/toc/toc.module').then(m => m.TocPageModule)
    },
    {
        path: 'credentials/:token',
        loadChildren: () => import('../app/pages/custom/skillsclub/credentials/credentials.module').then(m => m.CredentialsPageModule)
    },
    {
        path: 'credential/:id',
        loadChildren: () => import('../app/pages/custom/skillsclub/credential/credential.module').then(m => m.CredentialPageModule)
    }]
}
